

	import {Options, Vue} from "vue-property-decorator";

	@Options({})
	export default class TextField extends Vue
	{
		inheritAttrs = false;
	}
